import { createInitials } from 'global/common/dataAdjust'
import { SportsSeasonContext } from 'projectSpecific/sports/cnr/contexts/SportsSeasonContext'
import React from 'react'
import { Label } from 'semantic-ui-react'

const TeamResults = ({ team, teamMatchGroups }) => {

  const team_results = () => {
    const { name, record, _itemKey } = team ?? {}
    const { display } = record ?? {}
    const lbls = []
    const lbls_w = []
    const lbls_l = []
    const ms = teamMatchGroups?.[_itemKey]?.matches
    const tms = {
      wins: _.filter(ms, m => m?._results?.winner?.id === _itemKey || m?._results?.winner?._itemKey === _itemKey),
      losses: _.filter(ms, m => m?._results?.loser?.id === _itemKey || m?._results?.loser?._itemKey === _itemKey),
    }
    const _opps_w = []
    const _opps_l = []
    _.forEach(tms.wins, w => {
      const { home, away, _results } = w ?? {}
      let opp;
      if (home?._itemKey === _itemKey || home?.id === _itemKey) { opp = away }
      if (away?._itemKey === _itemKey || away?.id === _itemKey) { opp = home }
      _opps_w.push({ name: opp.name, win: true, result: _results?.scoreDisplays?.normal, ni: createInitials(opp.name, 3) })
    })
    _.forEach(tms.losses, l => {
      const { home, away, _results } = l ?? {}
      let opp;
      if (home?._itemKey === _itemKey || home?.id === _itemKey) { opp = away }
      if (away?._itemKey === _itemKey || away?.id === _itemKey) { opp = home }
      _opps_l.push({ name: opp.name, win: false, result: _results?.scoreDisplays?.normal, ni: createInitials(opp.name, 3) })
    })
    _.forEach(_opps_w, opp => {
      lbls_w.push(<Label title={opp.name} style={{ margin: '.25em' }} size='mini' color={opp.win ? 'green' : 'red'}>{`${opp.ni} ${opp.result}`}</Label>)
    })
    _.forEach(_opps_l, opp => {
      lbls_l.push(<Label title={opp.name} style={{ margin: '.25em' }} size='mini' color={opp.win ? 'green' : 'red'}>{`${opp.ni} ${opp.result}`}</Label>)
    })
    return <div style={{ display: 'flex', flexDirection: 'column', gap: '.25em', padding: '.5em', marginTop: '1em' }}>
      <div>{lbls_w}</div>
      <div>{lbls_l}</div>
    </div>
  }

  return team_results()

}

export default TeamResults
